import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.environmentName,
  enabled: !!environment.sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.production ? 0.1 : 1.0,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error exception captured',
  ],
});

bootstrapApplication(App, appConfig).catch((err) => {
  console.error(err);
  Sentry.captureException(err);
});
